import ProductDetailsFlashSale from '@/_application/modules/products/components/flash-sale/product-details-flash-sale';
import {PriceBox} from '@/_application/modules/products/components/price/price-box';
import {Product} from '@/_application/modules/products/model/product';
import {useAttributes} from '@/store/attributes/attributes.context';
import {isFlashSaleInStock} from '@/_application/modules/flash-sales/helper/flash-sale';
import {FlashSaleProductData} from '@/__generated__/__types__';
import ContentLoader from 'react-content-loader';

interface IProps {
    product: Product;
    flashSaleData?: FlashSaleProductData | null;
    isFlashSaleLoading?: boolean;
}

export const ProductDetailPrice = ({product, flashSaleData, isFlashSaleLoading = false}: Readonly<IProps>) => {
    const {selectedVariant} = useAttributes();

    if (isFlashSaleLoading) {
        return (
            <ContentLoader width={'100%'} height={54}>
                <rect x="0" y="0" rx="8" ry="8" width="100%" height="54" />
            </ContentLoader>
        );
    }

    return (
        <>
            {flashSaleData && isFlashSaleInStock(flashSaleData) ? (
                <ProductDetailsFlashSale product={product} flashSaleData={flashSaleData} />
            ) : (
                <div className="min-h-11 w-full md:flex md:min-h-fit md:items-center bg-white">
                    <PriceBox
                        product={product}
                        variant="details"
                        variation={selectedVariant}
                        useBasePrice={!!flashSaleData && !isFlashSaleInStock(flashSaleData)}
                    />
                </div>
            )}
        </>
    );
};
